import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  GeneralCardElements,
  LearningSessionStatus,
  OrdinaryClassProps,
  LearningSession,
  OrderedCardsList,
  User,
  CustomElement,
} from "@/types";
import { IonGrid, IonRow, IonCol } from "@ionic/vue";
import { reactive } from "vue";
import {
  executeLink,
  getCurrentElement,
  getCurrentSchoolYear,
  getCustomMessage,
} from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'LearningSessionsCards',
  async setup(__props) {

let __temp: any, __restore: any

const user = User.getLoggedUser() as User;

const learning_sessions: {
  current: OrderedCardsList<GeneralCardElements>;
  future: OrderedCardsList<GeneralCardElements>;
  upcoming: OrderedCardsList<GeneralCardElements>;
  completed: OrderedCardsList<GeneralCardElements>;
} = reactive({
  current: {
    order: [],
    cards: {},
  },
  future: {
    order: [],
    cards: {},
  },
  upcoming: {
    order: [],
    cards: {},
  },
  completed: {
    order: [],
    cards: {},
  },
});
const promises: Promise<any>[] = [];
const no_session: CustomElement = getCustomMessage(
  "emptiness_message",
  getCurrentElement("no_sessions")
);
const ordinary_classes: OrdinaryClassProps[] = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/ordinary_classes?student_id=" + user.id + "&descending=true",
  (response) => response.data.data
))),
  __temp = await __temp,
  __restore(),
  __temp
);
const current_class = ordinary_classes.shift();
const current_school_year =
  current_class != undefined
    ? current_class.school_year
    : getCurrentSchoolYear();

let tmp_element: GeneralCardElements | undefined,
  learning_session: LearningSession;
let open_enrollment = false,
  first = true;

if (current_class != undefined) {
  for (const oc of ordinary_classes) {
    promises.push(
      executeLink(
        "/v1/learning_sessions?school_year=" + oc.school_year,
        async (response) => {
          learning_sessions.completed.order.push({
            key: oc.school_year,
            title: getCustomMessage("title", oc.school_year, "title"),
          });
          learning_sessions.completed.cards[oc.school_year] = [];
          for (const session of response.data.data) {
            learning_session = new LearningSession(session);
            learning_sessions.completed.cards[oc.school_year].push(
              await learning_session.toCard(undefined)
            );
          }
        },
      )
    );
  }
  promises.push(
    executeLink(
      "/v1/learning_sessions?school_year=" + current_school_year,
      async (response) => {
        learning_sessions.completed.order.push({
          key: current_school_year,
          title: getCustomMessage("title", current_school_year, "title"),
        });
        learning_sessions.future.order = learning_sessions.future.order.concat(
          {
            key: "open_enrollment",
            title: getCustomMessage(
              "title",
              getCurrentElement("open_enrollment"),
              "title"
            ),
          },
          {
            key: "planned",
            title: getCustomMessage(
              "title",
              getCurrentElement("planned"),
              "title"
            ),
          }
        );
        learning_sessions.future.cards["open_enrollment"] = [];
        learning_sessions.future.cards["planned"] = [];

        for (const session of response.data.data) {
          learning_session = new LearningSession(session);
          tmp_element = await learning_session.toCard(
            undefined,
            undefined,
            undefined,
            undefined,
            true
          );

          switch (learning_session.getStatus()) {
            case LearningSessionStatus.FUTURE:
              if (learning_sessions.future.cards["planned"] == null) {
                learning_sessions.future.cards["planned"] = [];
              }
              if (first) {
                first = false;
                if (
                  !open_enrollment &&
                  learning_session.open_day <= new Date()
                ) {
                  open_enrollment = true;
                }
              }
              learning_sessions.future.cards["planned"].push(tmp_element);
              break;
            case LearningSessionStatus.UPCOMING:
              learning_sessions.upcoming.cards[""] = [tmp_element];
              break;
            case LearningSessionStatus.CURRENT:
              learning_sessions.current.cards[""] = [tmp_element];
              break;
            case LearningSessionStatus.COMPLETED:
              if (
                learning_sessions.completed.cards[session.school_year] ==
                undefined
              ) {
                learning_sessions.completed.cards[session.school_year] = [
                  tmp_element,
                ];
              } else {
                learning_sessions.completed.cards[session.school_year].push(
                  tmp_element
                );
              }
              break;
          }
        }

        if (
          open_enrollment &&
          (tmp_element = learning_sessions.future.cards["planned"].shift()) !=
            undefined
        ) {
          learning_sessions.future.cards["open_enrollment"].push(tmp_element);
        }
      }
    )
  );
  (
  ([__temp,__restore] = _withAsyncContext(() => Promise.all(promises))),
  await __temp,
  __restore()
); /*.then(() => {
      learning_sessions.loaded = true;
    });*/
  learning_sessions.completed.order.reverse();
  if (learning_sessions.completed.cards[current_school_year] == undefined) {
    learning_sessions.completed.cards[current_school_year] = [];
  }
}

return (_ctx: any,_cache: any) => {
  const _component_list_card = _resolveComponent("list-card")!

  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), {
            size: "12",
            "size-md": "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_list_card, {
                title: 
            _unref(getCustomMessage)('title', _unref(getCurrentElement)('current'), 'string', {
              text: {
                name: 'white',
                type: 'var',
              },
            })
          ,
                emptiness_message: _unref(no_session),
                cards_list: learning_sessions.current,
                colors: {
            list_borders: {
              name: 'white',
              type: 'var',
            },
            background: {
              name: 'current',
              type: 'var',
            },
            hover: {
              name: 'current',
              alpha: 0.54,
              type: 'var',
            },
            text: {
              name: 'white',
              type: 'var',
            },
            dividers: {
              name: 'white',
              type: 'var',
            },
          }
              }, null, 8, ["title", "emptiness_message", "cards_list", "colors"]),
              _createVNode(_component_list_card, {
                title: 
            _unref(getCustomMessage)('title', _unref(getCurrentElement)('future'), 'string', {
              text: {
                name: 'white',
                type: 'var',
              },
            })
          ,
                emptiness_message: _unref(no_session),
                cards_list: learning_sessions.future,
                colors: {
            background: {
              name: 'warning',
              type: 'var',
            },
            hover: {
              name: 'warning',
              alpha: 0.54,
              type: 'var',
            },
            dividers_text: {
              name: 'black',
              type: 'var',
            },
            list_borders: {
              name: 'white',
              type: 'var',
            },
            dividers: {
              name: 'white',
              type: 'var',
            },
          }
              }, null, 8, ["title", "emptiness_message", "cards_list", "colors"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), {
            size: "12",
            "size-md": "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_list_card, {
                title: 
            _unref(getCustomMessage)('title', _unref(getCurrentElement)('upcoming'), 'string', {
              text: {
                name: 'white',
                type: 'var',
              },
            })
          ,
                colors: {
            list_borders: {
              name: 'white',
              type: 'var',
            },
            background: {
              name: 'danger',
              type: 'var',
            },
            hover: {
              name: 'danger',
              alpha: 0.54,
              type: 'var',
            },
            text: {
              name: 'white',
              type: 'var',
            },
            dividers: {
              name: 'white',
              type: 'var',
            },
          },
                emptiness_message: _unref(no_session),
                cards_list: learning_sessions.upcoming
              }, null, 8, ["title", "colors", "emptiness_message", "cards_list"]),
              _createVNode(_component_list_card, {
                title: 
            _unref(getCustomMessage)(
              'title',
              _unref(getCurrentElement)('completed'),
              'string',
              {
                text: {
                  name: 'white',
                  type: 'var',
                },
              }
            )
          ,
                colors: {
            list_borders: {
              name: 'white',
              type: 'var',
            },
            background: {
              name: 'completed',
              type: 'var',
            },
            hover: {
              name: 'completed',
              alpha: 0.54,
              type: 'var',
            },
            text: {
              name: 'white',
              type: 'var',
            },
            dividers: {
              name: 'white',
              type: 'var',
            },
          },
                emptiness_message: _unref(no_session),
                cards_list: learning_sessions.completed
              }, null, 8, ["title", "colors", "emptiness_message", "cards_list"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})